export default __webpack_public_path__ + "static/media/orders.3fc64230.svg";